import { createI18n } from 'vue-i18n'
// import enUS from '../locales/en-US.json'
// import zhCN from '../locales/zh-CN.json'
import ptBR from '../locales/pt-BR.json' // 新增巴西葡萄牙语语言包
import enUS from '../locales/en-US.json' // 英文

// vant语言包
import vantPtBR from 'vant/es/locale/lang/pt-BR'
import vantEnUS from 'vant/es/locale/lang/en-US'

import { Locale } from 'vant'
import type { PickerColumn } from 'vant'
import { STORAGE_LANG_KEY } from '@/stores/mutation-type'

type AppLocale = 'en-US' | 'pt-BR'

const FALLBACK_LOCALE = 'pt-BR'

const vantLocales = {
  // 'zh-CN': zhCN,
  'pt-BR': vantPtBR,
  'en-US': vantEnUS,
}

export const languageColumns: PickerColumn = [
  // { text: '简体中文', value: 'zh-CN' },
  { text: 'English', value: 'en-US' },
  { text: 'Brazil', value: 'pt-BR' },
]

// 先确定初始语言，避免后续依赖问题
const initialLocale = getI18nLocale() || FALLBACK_LOCALE

export const i18n = createI18n({
  locale: initialLocale,
  legacy: false,
  messages: {
    'en-US': enUS,
    // 'zh-CN': zhCN,
    'pt-BR': ptBR, // 添加 pt-BR 支持
  },
})

Locale.use(initialLocale, vantLocales[initialLocale as AppLocale])
type I18n = typeof i18n

export const locale = computed({
  get() {
    return i18n.global.locale.value
  },
  set(language: AppLocale) {
    setLang(language, i18n)
    i18n.global.locale.value = language
  },
})

export async function setLang(lang: AppLocale, i18n: I18n) {
  await loadLocaleMsg(lang, i18n)

  document.querySelector('html').setAttribute('lang', lang)
  localStorage.setItem(STORAGE_LANG_KEY, lang)
  // 设置 vant 组件语言包
  Locale.use(lang, vantLocales[lang])
}

// 加载本地语言包
async function loadLocaleMsg(locale: string, i18n: I18n) {
  try {
    const messages = await import(`../locales/${locale}.json`)
    i18n.global.setLocaleMessage(locale, messages.default)
  } catch (error) {
    console.error(`Failed to load locale ${locale}:`, error)
    // 如果加载失败，回退到 fallback locale
    if (locale !== FALLBACK_LOCALE) {
      await loadLocaleMsg(FALLBACK_LOCALE, i18n)
    }
  }
}

// 获取当前语言对应的语言包名称
function getI18nLocale() {
  const storedLocale = localStorage.getItem(STORAGE_LANG_KEY) || navigator.language

  const langs = languageColumns.map((v) => v.value as string)

  // 存在当前语言的语言包 或 存在当前语言的任意地区的语言包
  const foundLocale = langs.find((v) => v === storedLocale || v.indexOf(storedLocale) === 0)

  // 若未找到，则使用 默认语言包
  const locale = foundLocale || FALLBACK_LOCALE

  return locale
}
